import React, { useCallback, useEffect, useState } from "react";
import { Card, Row, Col, Progress, Tag, Button, Input, Pagination } from "antd";
import {
  BookOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LIST_PACKAGE_COURSES, PACKAGE_COURSE_SUMMARY } from "../../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";

const PackageCourseBox = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { package_id } = useParams();

  const [courses, set_courses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [current_page, set_current_page] = useState(1);
  const [total_pages, set_total_pages] = useState(0);
  const [total_courses, set_total_courses] = useState(0);
  const [search_query_title, set_search_query_title] = useState("");
  const [completed, set_completed] = useState(0);
  const [inProgress, set_inProgress] = useState(0);
  const [notStarted, set_notStarted] = useState(0);

  useEffect(() => {
    const PACKAGE_COURSE_SUMMARY_LIST = async () => {
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("package_id", atob(package_id));
        const API_CALL = await PACKAGE_COURSE_SUMMARY(FORM_DATA);
        if (API_CALL?.data?.status) {
          const summary = API_CALL.data.data;
          set_total_courses(summary.total_courses || 0);
          set_completed(summary.completed_courses || 0);
          set_inProgress(summary.in_progress_courses || 0);
          set_notStarted(summary.not_started_courses || 0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    PACKAGE_COURSE_SUMMARY_LIST();
  }, [package_id]);

  //  Initial API Call
  useEffect(() => {
    const LIST_API = async () => {
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("package_id", atob(package_id));

        const API_CALL = await LIST_PACKAGE_COURSES(FORM_DATA);

        if (API_CALL?.data?.status) {
          set_courses(API_CALL.data?.data);
          set_total_courses(API_CALL.data?.total_courses);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    LIST_API();
  }, [package_id]);

  //  Pagination
  const pagination_on_change = async (page) => {
    set_pagination_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("package_id", atob(package_id));
    FORM_DATA.append("page", page);
    FORM_DATA.append("title", search_query_title);

    const API_CALL = await LIST_PACKAGE_COURSES(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_courses(API_CALL.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_courses(API_CALL?.data?.total_courses);
    }

    set_pagination_loader(false);
  };

  //  Debounced Search
  const debouncedSearch = useCallback(
    debounce(async (value) => {
      try {
        set_search_query_title(value);
        set_pagination_loader(true);

        const FORM_DATA = new FormData();
        FORM_DATA.append("package_id", atob(package_id));
        FORM_DATA.append("title", value);

        const API_CALL = await LIST_PACKAGE_COURSES(FORM_DATA);

        if (API_CALL?.data?.status) {
          set_courses(API_CALL.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_courses(API_CALL?.data?.total_courses);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500),
    [package_id]
  );

  const handleInput = (e) => {
    debouncedSearch(e.target.value);
  };



const stats = [
  {
    title: "Total Courses",
    value: total_courses,
    icon: (
      <Tag color="purple" style={{ fontSize: 18, padding: "6px 10px" }}>
        <BookOutlined style={{ fontSize: 20 }} />
      </Tag>
    ),
    color: "#7c3aed",
  },
  {
    title: "In Progress",
    value: inProgress,
    icon: (
      <Tag color="blue" style={{ fontSize: 18, padding: "6px 10px" }}>
        <PlayCircleOutlined style={{ fontSize: 20 }} />
      </Tag>
    ),
    color: "#3b82f6",
  },
  {
    title: "Completed",
    value: completed,
    icon: (
      <Tag color="green" style={{ fontSize: 18, padding: "6px 10px" }}>
        <CheckCircleOutlined style={{ fontSize: 20 }} />
      </Tag>
    ),
    color: "#10b981",
  },
  {
    title: "Not Started",
    value: notStarted,
    icon: (
      <Tag color="red" style={{ fontSize: 18, padding: "6px 10px" }}>
        <WarningOutlined style={{ fontSize: 20 }} />
      </Tag>
    ),
    color: "#ef4444",
  },
];

  return (
    <div className="lms-body">
      {/* 🔙 Back */}
      <span
        style={{
          fontSize: "16px",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          flexWrap: "wrap",
        }}
        onClick={() => Navigate("/packages")}
      >
        <ArrowLeftOutlined />
        Go to back
      </span>

      {/* 🔍 Search */}


      {/* 📊 Stats */}
      <Row gutter={16}>
        {stats.map((item, i) => (
          <Col xs={24} sm={12} md={12} lg={6} key={i}>
            <Card style={{ borderRadius: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ fontSize: 20, color: item.color }}>
                  {item.icon}
                </div>
                <div>
                  <h2 style={{ margin: 0 }}>{item.value}</h2>
                  <p style={{ margin: 0, color: "#94a3b8" }}>
                    {item.title}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      {/* 📚 Courses */}
      <Card style={{ marginTop: 30 }}>
        <div style={{ marginBottom: 20, marginTop: 10 }}>
          <Input
            addonBefore="Name"
            placeholder="Search courses..."
            onChange={handleInput}
            size="large"
          />
        </div>
        {loading ? (
          <CulsightPageLoader />
        ) : (
          courses.map((course, index) => {
            const progress = Math.round(course.progress || 0);

            let status = "Not Started";
            if (progress === 100) status = "Completed";
            else if (progress > 0) status = "In Progress";
            else status = "Not Started";
            return (<>

              <Card
                key={index}
                style={{ marginBottom: 20, borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                bodyStyle={{
                  display: "flex",
                  gap: 20,
                  flexWrap: "wrap",
                }}
              >
                {/* Image */}
                <img
                  src={course.thumbnail}
                  alt={course.title}
                  style={{
                    width: "100%",
                    maxWidth: 220,
                    borderRadius: 10,
                  }}
                />

                {/* Content */}
                <div style={{ flex: 1, minWidth: 250 }}>
                  <div style={{ marginBottom: 8 }}>
                    <Tag style={{ borderRadius: "10px" }}>
                      {course.language}
                    </Tag>
                  </div>

                  <h3 style={{ marginBottom: 5 }}>{course.title}</h3>

                  <p
                    style={{ color: "#94a3b8" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        course.course_tag_line?.slice(0, 120) + "...",
                    }}
                  ></p>

                  <div style={{ marginTop: 10 }}>
                    <Progress percent={progress} strokeColor="#7c3aed" />
                    <p style={{ color: "#94a3b8", marginTop: 5 }}>
                      {progress}% completed
                    </p>
                  </div>
                </div>

                {/* Right Section */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Tag color={status === "Completed" ? "green" : "blue"}>
                    {status}
                  </Tag>

                  <Button
                    type="primary"
                    style={{
                      background: "#10b981",
                      border: "none",
                    }}
                    onClick={() => Navigate(`/view-course/${btoa(course.id)}`)}
                  >
                    {status === "Completed" ? "Review" : "Start"}
                  </Button>
                </div>
              </Card>
            </>
            );
          })
        )}

        {/* Pagination */}
        {total_pages > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20,
            }}
          >
            <Pagination
              current={current_page}
              total={total_courses}
              pageSize={9}
              onChange={pagination_on_change}
            />
          </div>
        )}
      </Card>
    </div>
  );
};

export default PackageCourseBox;